import React, { useEffect, useRef, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import cn from 'clsx';
import useComponentUIHook from './useComponentUIHook';
import { SelectComponent, TextComponent } from '../../uiComponents';
import { SelectChangeEvent } from '@mui/material';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import { OptionProps } from '../../../view-models';
import { getJSONClaims } from '../../../store';
import DeleteIcon from '@mui/icons-material/Delete';
import { cloneDeep } from 'lodash';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import TemplatizedFieldComponent, { getTemplatizedValue, TemplatizedValue } from './templatizedFieldComponent';

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexColfill: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: '1',
      padding: '2px',
      overflow: 'hidden',
      '& .inline-tooltip': {
        marginTop: '10px',
      },
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    claim: {
      borderBottom: '1px solid grey',
      padding: 10,
    },
    pointer: {
      cursor: 'pointer',
    },
    icon: {
      cursor: 'pointer',
      marginLeft: '0.5rem',
    },
    justifyContent: {
      justifyContent: 'space-between',
    },
    marginRight: { marginRight: '20px' },
    marginLeft: { marginLeft: '20px' },
    displayAttribute: {
      flex: 1,
    },
    actions: {
      width: 90,
    },
  }),
);

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}
const GenerateAppInsightsUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, modifiedTemplatizations, setModifiedTemplatizations } = useComponentUIHook(componentData);
  const [claimsList, setClaimsList] = useState<OptionProps[]>([]);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const initAttribute = useRef(componentData['attribute']);
  const [updateAttr, setUpdateAttr] = useState<boolean>(false);
  const allClaims = useSelector(getJSONClaims);
  const classes1 = jsonEditorStyles();
  const classes = styles1();

  useEffect(() => {
    if (Object.keys(allClaims).length > 0) {
      const _temp = Object.keys(allClaims)
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setClaimsList(_temp);
    }
  }, [allClaims]);

  const onEditHandler = (attribute: any) => {
    setUpdateAttr(true);
    setModifiedData({
      ...modifiedData,
      attribute: attribute,
    });
  };

  const onDeleteHandler = (attr: string) => {
    const _attributes = modifiedData['claims'].filter((claim: string) => claim !== attr);
    setModifiedData({
      ...modifiedData,
      claims: _attributes,
    });
  };

  const submitData = (data: any, addFormSubmitAction: boolean) => {
    setDisableSubmit(false);
    closeGritComponent(data, modifiedTemplatizations, addFormSubmitAction);
  };

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res || (modifiedData['eventType'].trim() === ''));
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <div>
      <div>
        <div className={classes.flexRow}>
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              setModifiedData({ ...modifiedData, eventType: e.target.value });
            }}
            data={{
              value: modifiedData['eventType'] || '',
              label: 'Event Type',
              style: { margin: 1, width: 300 },
              required: true,
            }}
          />
          {/*<TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              setModifiedData({ ...modifiedData, instrumentationKey: e.target.value });
            }}
            data={{
              value: modifiedData['instrumentationKey'] || '',
              label: 'Instrumentation Key',
              style: { margin: 1, width: 500 },
            }}
          />*/}
          <TemplatizedFieldComponent
            modifiedTemplatizations={modifiedTemplatizations}
            setModifiedTemplatizations={setModifiedTemplatizations}
            data={{
              fieldPath: 'instrumentationKey',
              label: "Instrumentation Key",
              value: getTemplatizedValue(modifiedData['instrumentationKey']),
              style: { margin: 0, width: 600 },
              variant: 'text'
            }}
            changeHandler={(e: TemplatizedValue) => {
              setModifiedData({ ...modifiedData, instrumentationKey: { ...e } });
            }}
          />
        </div>
        <div className={cn(classes1.flexRowWrap)}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setModifiedData({
                ...modifiedData,
                attribute: { ...modifiedData['attribute'], claimId: e.target.value },
              });
            }}
            data={{
              value: modifiedData['attribute']['claimId'],
              label: 'Select Attribute',
              options: claimsList.filter((option: any) => !modifiedData['claims'].includes(option.value)),
              style: { margin: 1, width: 200 },
            }}
          />
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              setModifiedData({
                ...modifiedData,
                attribute: { ...modifiedData['attribute'], partnerClaimType: e.target.value },
              });
            }}
            data={{
              value: modifiedData['attribute']['partnerClaimType'] || '',
              label: 'PartnerClaim Type',
              style: { margin: 1, width: 200 },
            }}
          />
          {allClaims[modifiedData['attribute']['claimId']] &&
            allClaims[modifiedData['attribute']['claimId']]['dataType'] !== 'boolean' && (
              <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                  setModifiedData({
                    ...modifiedData,
                    attribute: { ...modifiedData['attribute'], defaultValue: e.target.value },
                  });
                }}
                data={{
                  value: modifiedData['attribute']['defaultValue'] || '',
                  label: 'Default Value',
                  style: { margin: 1, width: 200 },
                }}
              />
            )}
          {allClaims[modifiedData['attribute']['claimId']] &&
            allClaims[modifiedData['attribute']['claimId']]['dataType'] === 'boolean' && (
              <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                  setModifiedData({
                    ...modifiedData,
                    attribute: { ...modifiedData['attribute'], defaultValue: e.target.value },
                  });
                }}
                data={{
                  value: modifiedData['attribute']['defaultValue'] || '',
                  label: 'Default Value',
                  options: [
                    { label: 'true', value: 'true' },
                    { label: 'false', value: 'false' },
                  ],
                  style: { margin: 1, width: 200 },
                }}
              />
            )}

          <div>
            {!updateAttr && (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={modifiedData['attribute']['claimId'] === ''}
                onClick={() => {
                  setModifiedData({
                    ...modifiedData,
                    claims: [...modifiedData['claims'], modifiedData['attribute']],
                    attribute: initAttribute.current,
                  });
                }}
              >
                Add
              </Button>
            )}
            {updateAttr && (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={() => {
                  setModifiedData({
                    ...modifiedData,
                    claims: cloneDeep(modifiedData['claims']).reduce(
                      (acc: any, curAttr: any) =>
                        modifiedData['attribute']['claimId'] === curAttr['claimId']
                          ? acc.concat(modifiedData['attribute'])
                          : acc.concat(curAttr),
                      [],
                    ),
                    attribute: initAttribute.current,
                  });
                  setUpdateAttr(false);
                }}
              >
                Update
              </Button>
            )}
          </div>
        </div>

        <div>
          {modifiedData['claims'].map((attr: any, index: number) => (
            <div key={index} className={cn(classes.claim, classes1.flexRow)}>
              <div className={cn(classes1.flexRowWrap, classes.displayAttribute)}>
                <div className={classes.marginRight}>
                  <b>Claim Id:</b> {attr['claimId']}
                </div>
                <div className={classes.marginRight}>
                  <b>Partner Claim Type :</b> {attr['partnerClaimType']}
                </div>
                <div className={classes.marginRight}>
                  <b>Default Value :</b> {attr['defaultValue']}
                </div>
              </div>
              <div className={cn(classes1.flexRow, classes.actions)}>
                <ModeEditOutlineSharpIcon
                  onClick={() => onEditHandler(attr)}
                  className={classes.icon}
                  color="primary"
                />
                <DeleteIcon
                  onClick={() => {
                    window.confirm('Are you sure you want to delete ' + attr + '? This cannot be undone.') &&
                      onDeleteHandler(attr);
                  }}
                  className={classes.icon}
                  color="error"
                />
              </div>
            </div>
          ))}
        </div>
        <div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => {
              submitData(cloneDeep(modifiedData), false);
            }}
            disabled={disableSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
// export default withAITracking(reactPlugin, GenerateUserInputPageUI);
export default GenerateAppInsightsUI;
